import { Helmet } from 'react-helmet-async';
// sections
import { UserCreateView } from 'src/sections/mardam/tenants/view';

// ----------------------------------------------------------------------

export default function TenantCreatePage() {
  return (
    <>
      <Helmet>
        <title> Mardam: Create a new Tenant</title>
      </Helmet>

      <UserCreateView />
    </>
  );
}
